let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("impGx")).then(() => parcelRequire('NJGR7'));